import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

export const initialState = { accountId: null };

const accountIdSlice = createSlice({
	name: 'accountId',
	initialState,
	reducers: {
		accountIdAdded(state, action) {
			if (state) {
				return action.payload;
			}
			return state;
		}
	}
});

export const useAccountId = () => useSelector((state) => state.accountId);

export const { accountIdAdded } = accountIdSlice.actions;

export default accountIdSlice.reducer;
